var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent"},[_c('button',[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"material-icons"},[_vm._v(" arrow_forward_alt ")])])])])
}]

export { render, staticRenderFns }